export default {
    computed: {
        getBookingSteps() {
            return this.$store.getters['booking/getBookingSteps']
        },
        stepsBefore() {
            let index = this.cloneSteps().findIndex((step) => step.name === this.activeStep?.name)
            return this.cloneSteps().splice(0, index)
        },
        currentStep() {
            let index = this.cloneSteps().findIndex((step) => step.name === this.activeStep?.name)
            return this.cloneSteps()[index]
        },
        stepsAfter() {
            let index = this.cloneSteps().findIndex((step) => step.name === this.activeStep?.name)
            return this.cloneSteps().splice(index + 1)
        },
        visibleStepsBefore() {
            return this.stepsBefore.filter((step) => !step.hidden)
        },
        visibleStepsAfter() {
            return this.stepsAfter.filter((step) => !step.hidden)
        },
        activeStep() {
            if (this.stepName) {
                return this.getBookingSteps.find((step) => step.name === this.stepName)
            }
            let sortedSteps = this.cloneSteps()
            sortedSteps.sort(function (a, b) {
                return b.name.length - a.name.length;
            });

            for (let step of sortedSteps) {
                if (this.$route.name.includes('booking-id-' + step.name)) {
                    return step
                }
            }
        }
    },
    methods: {
        nextStep() {
            this.redirectUserToEnabledStep(true)
        },
        previousStep() {
            this.redirectUserToEnabledStep(false, true)
        },
        cloneSteps() {
            return this.$cloneDeep(this.getBookingSteps)
        },
        redirectUserToEnabledStep(nextStep = false, previousStep = false) {
            const activeStepIndex = this.getBookingSteps.findIndex((step) => step.name === this.activeStep?.name)
            let goToStep = null;
            //First look ahead, maybe this step is just disabled because it is unnecessary for this user
            for (let i = activeStepIndex + (nextStep ? 1 : 0); i < this.getBookingSteps.length; i++) {
                if (!this.getBookingSteps[i].disabled && !this.getBookingSteps[i].hidden) {
                    goToStep = this.getBookingSteps[i].name
                    break;
                }
            }
            if (!goToStep || previousStep) {
                //Now lets look back, if no step ahead is active, we have some errors to fix
                for (let i = activeStepIndex - (previousStep ? 1 : 0); i >= 0; i--) {
                    if (!this.getBookingSteps[i].disabled && !this.getBookingSteps[i].hidden) {
                        goToStep = this.getBookingSteps[i].name
                        break;
                    }
                }
            }
            if (!goToStep || goToStep === this.activeStep?.name) {
                return;
            }
            this.$router.replace(
                {
                    path: this.$localePath({name: 'booking-id-' + goToStep}),
                    query: this.$route.query
                })
        }
    }
}
